<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 15 15">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.31309 0.964815C5.31309 0.478076 5.70767 0.0834961 6.19441 0.0834961H14.1263C14.613 0.0834961 15.0076 0.478076 15.0076 0.964815C15.0076 1.45155 14.613 1.84613 14.1263 1.84613H10.8083L6.95251 12.422H9.71969C10.2064 12.422 10.601 12.8165 10.601 13.3033C10.601 13.79 10.2064 14.1846 9.71969 14.1846H1.78781C1.30107 14.1846 0.906494 13.79 0.906494 13.3033C0.906494 12.8165 1.30107 12.422 1.78781 12.422H5.10581L8.96158 1.84613H6.19441C5.70767 1.84613 5.31309 1.45155 5.31309 0.964815Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
